<template>
  <div class="container">
    <!--banner-->
    <!-- <div class="header">
      <div class="logo">
        {{ siteName }}
        <div class="sub-title">赋予创造财富的能力</div>
      </div>
      <div class="propagate">
        <span class="eight-font">慧眼:慧商;汇财:惠邦</span>
      </div>
      <div class="user-info-cover">
        <div class="user-info">
          <div class="hot-line">
            全国统一服务电话<br/>400-006-8609
          </div>
          <el-link style="color: #0000ff" :underline="false">
            <img
              :src="require('@/assets/images/store_car.png')"
              style="width: 16px; height: 16px; margin-right: 2px"
            />爱品慧<el-icon class="el-icon--right"></el-icon>
          </el-link>

        </div>
        <div class="company">
          上海慧邦财务管理咨询有限公司&nbsp;&nbsp;成都慧邦智慧科技有限公司
        </div>
      </div>

    </div> -->

    <!-- header -->
    <!-- <div class="blank-banner">
      <div class="propagate">
        <div class="propagate_1">
          财经“智慧+智能”<span class="orange">应用与服务平台</span>
        </div>
        <div class="propagate_2">把智慧转化为生产力，让财经变得简单、高效!</div>
      </div>
      <div class="blank-banner-right">
        <div class="user-info">
          <template v-if="isLogined == null">
            <el-link
              class="user-info-text"
              :underline="false"
              @click="showLogin(1)"
              >用户登录</el-link
            >
            <el-link
              class="user-info-text"
              :underline="false"
              @click="showLogin(0)"
              >用户注册</el-link
            >
            <el-link
              class="user-info-text"
              :underline="false"
              >用户中心</el-link
            >
          </template>
          <template v-else>
            <span class="welcome-str">欢迎您，xxx用户</span>
            <el-link :underline="false" @click="userLogout">退出登录</el-link>
          </template>
        </div>
        <div class="consult-platform">
              <div class="item-content" @click="openUrl('/cusconsult')">
                <div class="icon">
                  <span class="fa fa-phone"></span>&nbsp;
                  <span class="name">在线咨询平台</span>
                </div>
              </div>
        </div>
      </div>

    </div> -->

    <!-- header -->
    <div class="header">
      <h1 class="logo">
        <img src="./assets/logo.png" alt="">
      </h1>
      <div class="topic">
        <h4>财经“智慧+智能”应用与服务平台</h4>
        <span>把智慧转化为生产力，让财经变得简单、高效</span>
      </div>
      <div class="info">
        <h5>慧眼 : 惠商 ; 汇财 : 慧邦</h5>
        <div class="mobile">全国统一服务电话  400-006-8609</div>
        <div class="company">上海慧邦财务管理咨询有限公司  成都慧邦智慧科技有限公司</div>
      </div>
      <div class="blank-banner-right">
        <div class="consult-platform">
            <div class="item-content" @click="openUrl('/cusconsult')">
              <div class="icon">
                <span class="fa fa-phone"></span>&nbsp;
                <span class="name">在线咨询平台</span>
              </div>
            </div>
            <el-link style="color: #0095fa" :underline="false">
              <img
                :src="require('@/assets/images/store_car.png')"
                style="width: 16px; height: 16px; margin-right: 2px"
              />爱品慧
              <el-icon style="color: #0095fa"><ArrowRight /></el-icon>
            </el-link>

        </div>
        <div class="user-info">
          <template v-if="isLogined == null">
            <el-link
              class="user-info-text"
              :underline="false"
              @click="showLogin(1)"
              >用户登录</el-link
            >
            <el-link
              class="user-info-text"
              :underline="false"
              @click="showLogin(0)"
              >用户注册</el-link
            >
            <el-link
              class="user-info-text"
              :underline="false"
              >用户中心</el-link
            >
          </template>
          <template v-else>
            <span class="welcome-str">欢迎您，xxx用户</span>
            <el-link :underline="false" @click="userLogout">退出登录</el-link>
          </template>
        </div>

      </div>
    </div>

    <!--menu-->
    <div class="menu">
      <div
        :class="activeMenuId === -1 ? 'menu-item active' : 'menu-item'"
        @click="goSubsystem(-1)"
      >
        首页
      </div>
      <template v-for="menu in menuList" :key="menu.path">
        <div v-if="menu.props.path !== 'footer/' && menu.props.path !== 'consult/'" >
          <div :class="activeMenuId === menu.id ? 'menu-item active' : 'menu-item'"
            @click="goSubsystem(menu)">{{ menu.label }}</div>
        </div>
      </template>
    </div>

    <!-- banner -->
    <!-- swiper-pagination-bullet swiper-pagination-bullet-active -->

    <!--入口-->
    <div class="entry">
      <router-view />
    </div>
    <!--页脚-->
    <el-footer>
      <div class="friend-link">
        <!-- item.props.path.substr(7) -->
        <div class="link-item" @click="openUrl('/footer',item.props.path.substr(7))" v-for="item in footerList" :key="item.id">{{ item.label }}<span>|</span></div>
        <!-- <div class="link-item" @click="openUrl('/service')">服务网点</div>
        <div>|</div>
        <div class="link-item" @click="openUrl('/serviceteam')">服务团队</div>
        <div>|</div>
        <div class="link-item" @click="openUrl('/dynamic')">慧邦动态</div>
        <div>|</div>
        <div class="link-item" @click="openUrl('/statement')">法律声明</div> -->
      </div>
      <div class="copyright-info">
        <div>上海慧邦财务管理咨询有限公司</div>
        <div>成都慧邦智慧科技有限公司</div>
        <div>四川省慧邦爱信会计师事务所有限公司</div>
        <div>四川省慧邦爱诚税务师事务所有限公司</div>
        <div>四川省慧邦爱品电子商务有限公司</div>
        <div>版权所有</div>
      </div>
    </el-footer>
  </div>
  <!--客服边栏-->
  <div class="customer-service">
    <CustomerService></CustomerService>
  </div>
  <el-dialog
    v-model="dialogFormVisible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    align-center
    destroy-on-close
    :title="dialogTitle"
    @closed="dialogFormVisible = false"
  >
    <Login :type="dialogType" @complete="dialogFormVisible = false"></Login>
  </el-dialog>
</template>
<script setup>
import { ArrowRight } from '@element-plus/icons-vue'
import { computed, ref, reactive, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import CONFIG from '@/assets/config.json'
import { ElMessageBox } from 'element-plus'
import CustomerService from '@/components/common/CustomerService.vue'
import Login from '@/components/common/Login.vue'
// import { logout } from '@/api'

// const swiperOptions = ref({
//   // Swiper的配置选项
//   loop: true,
//   autoplay: {
//     delay: 1000, // 1秒切换一次
//     disableOnInteraction: false // 悬停不动
//   },
//   // 小圆点
//   pagination: {
//     el: '.swiper-pagination'
//   }
// })
const store = useStore()
const router = useRouter()
let menuList = computed(() => store.getters.getMenuList)
let footerList = computed(() => store.getters.getFooterList) // 从本地获取
const activeMenuId = computed(() => store.getters.getActiveMenuId)
let siteName = ref('慧邦财经')
const dialogFormVisible = ref(false)
const dialogTitle = ref('用户登录')
const dialogType = ref(1)
const isLogined = computed(() => store.getters.getToken)
const form = reactive({
  name: '',
  region: '',
  date1: '',
  date2: '',
  delivery: false,
  type: [],
  resource: '',
  desc: ''
})
const getMenuList = () => {
  fetch(CONFIG.BASE_API_URL + 'cms/catalog/web/treeData')
    .then((response) => {
      const contentType = response.headers.get('content-type')
      return response.json()
    })
    .then((data) => {
      if (data.code === 200) {
        store.commit('setMenuList', data.data.rows)
        menuList = data.data.rows
        // console.log(menuList)
        // 获取页脚内容
        footerList = data.data.rows.filter(item => item.id === '453811282763845')[0].children
        // console.log(footerList)
        // 本地存储
        store.commit('setFooterList', footerList)
        siteName = data.data.siteName
      }
    })
  // 存储咨询电话
  menuList.value.forEach((menu) => {
    if (menu.props.path === 'consult/') {
      menu.children.forEach((item) => {
        if (item.props.path === '/consult/service/') {
          store.commit('setServeconsult', item.props.description)
        } else if (item.props.path === '/consult/application/') {
          store.commit('setAppconsult', item.props.description)
        } else if (item.props.path === '/consult/customer/') {
          store.commit('setCusveconsult', item.props.description)
        }
      })
    }
  })
}
getMenuList()

// 获取页脚数据
// console.log(menuList)
// const footerList = menuList.value.filter(item => item.id === '453811282763845')[0].children
// console.log(footerList[0].label)

const goSubsystem = (menu) => {
  if (menu === -1 && activeMenuId.value !== -1) {
    store.commit('setActiveMenuId', -1)
    store.commit('setActiveSubMenuId', -1)
    router.push({
      name: 'home'
    })
  } else if (menu !== -1 && activeMenuId.value !== menu.id) {
    console.log('haha')
    fetch(CONFIG.BASE_API_URL + 'cms/catalog/web/treeData')
      .then((response) => {
        const contentType = response.headers.get('content-type')
        return response.json()
      })
      .then((data) => {
        if (data.code === 200) {
          store.commit('setMenuList', data.data.rows)
          menuList = data.data.rows
          siteName = data.data.siteName
        }
      })
    store.commit('setActiveMenuId', menu.id)
    store.commit('setActiveSubMenuId', -1)
    store.commit('setActiveSubMenuList', menu.children)
    if (window.location.hash !== '#/subsystem/home') {
      router.push({
        name: '/subsystem/home'
      })
    }
  }
}
const openUrl = async (url, name = '') => {
  await fetch(CONFIG.BASE_API_URL + 'cms/catalog/web/treeData')
    .then((response) => {
      const contentType = response.headers.get('content-type')
      return response.json()
    })
    .then((data) => {
      if (data.code === 200) {
        store.commit('setMenuList', data.data.rows)
        menuList = data.data.rows
        siteName = data.data.siteName
      }
    })
  store.commit('setActiveMenuId', -2)
  store.commit('setActiveSubMenuId', -2)
  router.push({
    path: url,
    query: {
      name
    }
  })
}
// 打开登录面板，1-登录；0-注册
const showLogin = (type) => {
  dialogTitle.value = type === 1 ? '用户登录' : '用户注册'
  dialogType.value = type
  dialogFormVisible.value = true
}
// 退出登录
const userLogout = () => {
  ElMessageBox.confirm('确认退出登录？', '提示', {
    showClose: false,
    cancelButtonText: '取消',
    confirmButtonText: '确定'
  })
    .then(async () => {
      // const res = await logout()
      // if (res.code === 200) {
      //   store.commit('clearToken')
      // }
      // TODO 完成网络接口调用
      store.commit('clearToken')
    })
    .catch(() => {})
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.container {
  width: 1124px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  .header{
    width: 100%;
    height: 80px;
    // margin: 0 30px;
    display: flex;
    align-items: center;
    .logo{
      margin-right: 40px;
      height: 45px;
      img{
        height: 100%;
      }
    }
    .topic{
      h4{
        font-size: 17px;
        font-weight: 700;
        margin-bottom: 5px;
      }
      span{
        font-size: 12px;
        color: #ff9100;
      }
    }
    .info{
      // margin-right: -42px;
      font-size: 12px;
      .mobile{
        color: #0095fa;
      }
      .company{
        margin-top: -5px;
        font-size: 18px;
        transform: scale(0.5);
      }
    }
    .blank-banner-right{
      .consult-platform{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-content{
          width: 90px;
          border: 1px solid #575757;
          border-radius: 6px;
          padding: 2px;
          color: #575757;
          font-size: 12px;
          transition: 0.2s;
          &:hover{
            color: #fa8231;
            border-color: #fa8231;
          }
        }
      }
      .user-info {
        background-color: #e8eaec;
        height: 25px;
        line-height: 25px;
        margin: 8px 0px;
        border-radius: 6px;
        .user-info-text {
          padding: 0px 8px;
          transition: 0.2s;
          font-size: 12px;
          &:hover{
            background-color: #d9dcdd;
          }
        }
      }
    }
  }
  // .header {
  //   width: 100%;
  //   // background: url("./assets/images/banner-6.jpg") center bottom;
  //   display: flex;
  //   justify-content: space-between;
  //   .logo {
  //     font-size: 40px;
  //     margin-left: 30px;
  //     line-height: 100px;
  //     font-family: "微软雅黑";
  //     font-weight: bolder;
  //     color: blue;
  //     text-shadow: 0px 0px 20px white, 0px 0px 10px #fff, 0px 0px 10px #fff,
  //       0px 0px 10px #fff;
  //     .sub-title {
  //       font-size: 14px;
  //       line-height: 20px;
  //       color: #fa8231;
  //       text-shadow: none;
  //       margin-top: -20px;
  //     }
  //   }
  //   .propagate {
  //     color: #345dbb;
  //     font-size: 28px;
  //     font-weight: bolder;
  //     // text-align: left;

  //     // .orange{
  //     //   color:#fd9644;
  //     // }
  //     .eight-font {
  //       color: #345dbb;
  //       font-size: 28px;
  //       text-shadow: 0 0 10px #fff, 0 0 30px #fff;
  //       line-height: 120px;
  //       letter-spacing: 4px;
  //     }
  //   }
  //   .user-info {
  //     display: flex;
  //     align-items: center;
  //     height: 40px;

  //     a {
  //       color: #fff;
  //       margin: 8px 5px;
  //       font-size: 14px;
  //       text-decoration: none;
  //       &:last-child {
  //         // margin-right: 20px;
  //       }
  //     }
  //     .hot-line{
  //       color: #a5221d;
  //       font-size: 15px;
  //       margin-right: 20px;
  //     }
  //   }
  //   .user-info-cover{
  //     position: relative;
  //     height:120px;
  //     .company{
  //       width: max-content;
  //       position: absolute;
  //       bottom: 6px;
  //       right: 10px;
  //       color: #345dbb;
  //       font-weight: bold;
  //     }
  //   }
  // }
  // .blank-banner {
  //   height:78px;
  //   display: flex;
  //   justify-content: space-between;
  //   background-image: linear-gradient(28deg,#eef1f4,33%,#fff);
  //   .propagate {
  //     color: #345dbb;
  //     font-size: 24px;
  //     font-weight: bolder;
  //     text-align: left;
  //     margin-left: 35px;
  //     display: flex;
  //     justify-items: auto;
  //     .orange {
  //       color: #fd9644;
  //     }
  //     .propagate_1 {
  //       padding: 25px 0px;
  //     }
  //     .propagate_2 {
  //       color: #345dbb;
  //       font-size: 18px;
  //       margin-top: 30px;
  //       padding-left: 40px;
  //       font-family: Arial, Helvetica, sans-serif;
  //     }
  //   }
  //   .user-info {
  //     background-color: #e8eaec;
  //     height: 30px;
  //     line-height: 30px;
  //     margin: 8px 6px 8px 0px;
  //     border-radius: 6px;
  //     .welcome-str {
  //       font-size: 14px;
  //       color: #fff;
  //       margin: 0px 5px;
  //     }
  //     .user-info-text {
  //       padding: 0px 10px;
  //       transition: 0.2s;
  //       &:hover{
  //         background-color: #d9dcdd;
  //       }
  //     }
  //   }
  //   .consult-platform{
  //     text-align: center;
  //     padding-right: 5px;
  //     .item-content{
  //       width: 105px;
  //       display: block;
  //       border: 1px solid #575757;
  //       border-radius: 6px;
  //       margin-left: auto;
  //       padding: 2px;
  //       color: #575757;
  //       font-size: var(--el-link-font-size);
  //       margin-bottom: 8px;
  //       transition: 0.2s;
  //       &:hover{
  //         color: #fa8231;
  //         border-color: #fa8231;
  //       }
  //     }
  //   }
  // }
  .menu {
    width: calc(100% - 20px);
    height: 50px;
    background-color: #15a2fb;
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    flex-wrap: nowrap;
    box-shadow: 0 3px 3px #ccc;
    .menu-item {
      width: auto;
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
      padding-right: 15px;
      margin-top: 0px;
      color: #fff;
      font-weight: 700;
      cursor: pointer;
      // font-size: 16px;
      transition: 0.2s;
      &.active {
        background: #2f71e5;
        cursor: default;
      }
      &:hover {
        background: #2f71e5;
      }
    }
  }
  .entry {
    margin: 0;
  }
  .el-footer {
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // align-content: center;
    width: 100%;
    height: 80px;
    padding: 15px 0 0;
    background: #2d3237;
    color: #fff;
    .copyright-info {
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin-top: 5px;
      div{
        padding: 5px;
      }
    }
    .friend-link {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .link-item {
        cursor: pointer;
        span{
          display: inline-block;
          vertical-align: text-bottom;
          margin: 0 10px;
        }
        &:last-child span{
            display: none;
        }
      }
    }
  }
}
.customer-service {
  position: fixed;
  top: 50%;
  z-index: 10000;
  padding: 0;
  right: 0;
}

</style>
